import React from 'react'
import { RoomSession } from '../../models/Room'
import { parseMetadata } from '../../common/util'
import { Tooltip } from '../../components/Tooltip/Tooltip'
import { selectSafeAuthenticatedUser } from '../../store/auth/authSlice'
import { useAppSelector } from '../../store/hooks'

export interface IncompleteBadgeProps {
  roomSession: RoomSession
}

export const IncompleteBadge: React.FC<IncompleteBadgeProps> = ({ roomSession }) => {
  const { id: currentUserId } = useAppSelector(selectSafeAuthenticatedUser)
  const { source = 'voice-memo', creator_service_id: creatorServiceId, external: { title = null } = {} } = parseMetadata(roomSession.metadata)
  if (
    source !== 'voice-memo' ||
    roomSession.users.length ||
    title ||
    roomSession.isActive ||
    creatorServiceId ||
    roomSession.roomCreatedBy?.id !== currentUserId
  ) {
    return null
  }
  return (
    <Tooltip
      className='paragraph-small'
      title="Add Clients for better AI assistance, or start the meeting anytime you're ready"
      placement='top'
      offset={[0, 10]}
    >
      <div className='d-flex align-items-center align-content-center zocks-border-primary-light zocks-bg-color-gray-200 p-1 zocks-border-0.25 gap-2'>
        <span className='button-small'>Incomplete</span>
      </div>
    </Tooltip>
  )
}
